module.exports = __webpack_public_path__ + "static/chrisliebing_0-4843a5fdf05df5e0c71eaab78fe49aef.jpg";